import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { TotalTableContent } from './total-table-content';
import { GainLossLayout } from '../gain-loss-layout';
import { AllocationsGainLossEnum } from '../../../../../../models/enums/allocations-gain-loss-enum';

export const TotalTable: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <GainLossLayout
            gainTitle={t('layout.tables.allocations.total.gain.title')}
            gainTooltip={t('layout.tables.allocations.total.gain.tooltip')}
            lossTitle={t('layout.tables.allocations.total.loss.title')}
            lossTooltip={t('layout.tables.allocations.total.loss.tooltip')}
            gainContent={<TotalTableContent type={AllocationsGainLossEnum.Gain} />}
            lossContent={<TotalTableContent type={AllocationsGainLossEnum.Loss} />}
        />
    );
});
